const {
  REACT_APP_IBAN_HOST_API: hostApi,
  REACT_APP_IBAN_API: ibanApi,
  REACT_APP_IBAN_AUTH_API: ibanAuthApi,
  REACT_APP_INSURANCE_LOANS_URL,
  REACT_APP_IBAN_API_DEV_NEW: crmApi,
  REACT_APP_IBAN_API_DOCUMENT: crmDocumentApi,
} = process.env;

const authAppName = 'do-erp';
const clientAreaAuthAppName = 'do-client-area';

const setUrl = path => `${hostApi}/${path}`;
const setApiUrl = path => `${ibanApi}/${path}`;
const setAuthApiUrl = path => `${ibanAuthApi}/${authAppName}/${path}`;
const UrlsetAuthApi = path => `${ibanAuthApi}/${path}`;
const setClientAreaAuthApiUrl = path =>
  `${ibanAuthApi}/${clientAreaAuthAppName}/${path}`;
const setDocumentApiUrl = path => `${crmDocumentApi}/${path}`;
const setCrmApi = path => `${crmApi}/api/v1/${path}`;

// Api urls
export const loanAppUrl = setApiUrl('loan-applications');
export const loansUrl = setApiUrl('loans');
export const transactionsUrl = (rest = '') => setApiUrl(`transactions${rest}`);

// Requests url
export const requestHistoryUrl = loanId =>
  setApiUrl(`loan-applications/${loanId}/get-activities`);
export const filterRequestsUrl = setUrl('filter.php');
export const countRequestsUrl = setUrl('count.php');
export const updateRequestStatusUrl = setUrl('situacion.php');
export const updateRequestNoteUrl = loanId =>
  setApiUrl(`loan-applications/${loanId}/insert-activity`);
export const getDocumentsUrl = loanId =>
  setApiUrl(`loan-applications/${loanId}/get-document`);
export const deleteImageUrl = (loanId, fileName) =>
  setApiUrl(`documentation/${loanId}/?=fileName=${fileName}`);
export const editImageName = (fileName, renamedFileName) =>
  setApiUrl(
    `documentation/rename?fileName=${fileName}&renamedFileName=${renamedFileName}`
  );
export const uploadImageUrl = loanId =>
  setDocumentApiUrl(`loan-applications/${loanId}/upload-document-with-drive`);
export const updateRequestFieldUrl = setUrl('updateSolicitud.php');
export const uploadUnnaxDocumentsUrl = () => setCrmApi('documents-upload/kyc');
export const unnaxUrl = path => setCrmApi(`unnax/${path}`);

export const archivedRequestsUrl = setUrl('filterArchivado.php');
export const expensesRequestUrl = loanId => setApiUrl(`expenses/${loanId}`);
export const updateExpensesRequestUrl = setApiUrl('expenses');
export const RemoveExpensesRequestUrl = (loanId, expensesId) =>
  setApiUrl(`expenses/${expensesId}`);
export const getRequestUrlByRequestId = requestId =>
  `${loanAppUrl}/${requestId}`;

export const getPersonalReferencesUrl = loanId =>
  setApiUrl(`loan-application-references/${loanId}`);

export const getRepresentativeUrl = loanId =>
  setApiUrl(`legal-person-representatives/${loanId}`);

// Loans
export const loanProjectionUrl = `${loansUrl}/projection`;
export const makeLoanPaymentUrlByLoandId = loanId =>
  `${loansUrl}/${loanId}/payments`;
export const createLoanContractUrl = `${loansUrl}/create-loan-contract`;
export const createPromissoryNoteUrl = `${loansUrl}/create-promissory-note`;
export const applyDiscountUrl = (loanId, dueId) =>
  `${loansUrl}/${loanId}/dues/${dueId}/apply-discount`;
export const insuranceLoanUrl = REACT_APP_INSURANCE_LOANS_URL;
export const updateLoanUrl = loanId => `${loansUrl}/${loanId}`;

// Auth/Profile url
export const signUpUrl = setUrl('userv2.php');
export const signUpIbanUrl = `${ibanAuthApi}/users`;
export const registrationTokenUrl = `${ibanAuthApi}/users/registration-token`;
export const createProfileUrl = userId =>
  setAuthApiUrl(`users/${userId}/profile`);
export const signInUrl = setAuthApiUrl('token');
export const retrieveProfileByTokenUrl = setAuthApiUrl('profiles/me');
export const retrieveProfileByUserIdUrl = userId =>
  setAuthApiUrl(`profiles/${userId}`);
export const retrieveClientAreaProfileByUserIdUrl = userId =>
  setClientAreaAuthApiUrl(`profiles/${userId}`);
export const getProfilesUrl = setAuthApiUrl('profiles');
export const getClientAreaProfilesUrl = setClientAreaAuthApiUrl('profiles');
// Delete user
export const deleteUserUrl = userId => UrlsetAuthApi(`users/${userId}`);
// Patch user
export const patchUserUrl = userId => UrlsetAuthApi(`do-erp/users/${userId}`);
export const userUrl = userId => UrlsetAuthApi(`user/${userId}`);
export const resetPasswordUrl = token =>
  UrlsetAuthApi(`user/${token}/reset-password`);

// Permissions Url
export const getPermissionsUrl = setAuthApiUrl('permissions');
export const createPermissionsUrl = setAuthApiUrl('permissions');
export const grantPermissionsToUserUrl = userId =>
  setAuthApiUrl(`users/${userId}/grant-permissions`);
export const revokePermissionsToUserUrl = userId =>
  setAuthApiUrl(`users/${userId}/revoke-permissions`);

export const deletePermissionsUrl = permissionId =>
  UrlsetAuthApi(`permissions/${permissionId}`);
export const patchPermissionsUrl = permissionId =>
  UrlsetAuthApi(`permissions/${permissionId}`);
// Transactions
export const transactionsSummaryUrl = transactionsUrl('/summary');
export const transactionsSummaryOfficesUrl = transactionsUrl(
  '/summary/offices'
);

// Bank accounts
export const bankAccountsUrl = (rest = '') => setApiUrl(`bank-accounts${rest}`);
export const getBankAccountByIdUrl = bankAccountId =>
  bankAccountsUrl(`/${bankAccountId}`);
export const bankAccountBalancesUrl = bankAccountId =>
  bankAccountsUrl(`/${bankAccountId}/balances`);

// Brokers
export const brokersUrl = (rest = '') => setApiUrl(`brokers${rest}`);

// Groups
export const groupsUrl = (rest = '') => UrlsetAuthApi(`groups${rest}`);
// post Url Groups
export const postGroupsUrl = () => UrlsetAuthApi(`groups`);
// delete Url Groups
export const deleteGroupsUrl = (rest = '') => UrlsetAuthApi(`groups/${rest}`);
// patch Url Groups
export const patchGroupsUrl = (rest = '') => UrlsetAuthApi(`groups/${rest}`);

// Departments
export const departmentsUrl = (rest = '') =>
  UrlsetAuthApi(`departments${rest}`);
// post Url Departments
export const postDepartmentsUrl = () => UrlsetAuthApi(`departments`);
// delete Url Departments
export const deleteDepartmentsUrl = (rest = '') =>
  UrlsetAuthApi(`departments/${rest}`);
// patch Url Departments
export const patchDepartmentsUrl = (rest = '') =>
  UrlsetAuthApi(`departments/${rest}`);

// Positions
export const positionsUrl = (rest = '') => UrlsetAuthApi(`positions${rest}`);
// post Url Positions
export const postPositionsUrl = () => UrlsetAuthApi(`positions`);
// delete Url Positions
export const deletePositionsUrl = (rest = '') =>
  UrlsetAuthApi(`positions/${rest}`);
// patch Url Positions
export const patchPositionsUrl = (rest = '') =>
  UrlsetAuthApi(`positions/${rest}`);

// get Supervisor
export const supervisorUrl = () =>
  UrlsetAuthApi(`do-erp/profiles/supervisors/`);

// get KYC
export const kycandamlUrl = (id = '') =>
  UrlsetAuthApi(`api/v1/unnax/get-status/${id}`);

// know ip address
export const ipUrl = 'https://ipapi.co/json/';

// get loanApplication checklist
// The country manage in the backend: DO = 1, MX = 2
export const checklistUrl = (id = '', country = 1) =>
  `${crmApi}/api/v1/loan-application-checklist/loan-application/${id}/${country}`;

// post loanApplication checklist
export const postChecklistUrl = () =>
  `${crmApi}/api/v1/loan-application-checklist`;

// delete loanApplication checklist
export const deleteChecklistUrl = (loanId, taskId) =>
  `${crmApi}/api/v1/loan-application-checklist/${loanId}/${taskId}`;



// WEBPACK FOOTER //
// ./src/utils/constants/endpointUrls.js